import React, { Component } from "react";
import "component/list/FilterList/styles.scss";
import ScrollDirectionTracker from "utils/ScrollDirectionTracker";

class FitlerList extends Component {
  constructor(props) {
    super(props);
    this.state = { isNavHidden: false };

    this.scrollTracker = new ScrollDirectionTracker({
      scrollContainerSelector: ".history",
      threshold: 8,
      topOffset: 20,
      onChange: (isHidden) => this.setState({ isNavHidden: isHidden }),
    });
  }

  componentDidMount() {
    this.scrollTracker.start();
  }

  componentWillUnmount() {
    this.scrollTracker.stop();
  }

  render() {
    if (this.props.list && this.props.list.size <= 1) return null;

    const { isNavHidden } = this.state;

    return (
      <div className={`filter-list ${isNavHidden ? "nav-hidden" : ""}`}>
        {this.props.list &&
          this.props.list.map((item, key) => {
            return (
              <span
                className={`badge badge-${
                  this.props.selectedIndex === key ? "toggled" : "secondary"
                }`}
                data-testid={this.props.itemTestId}
                key={key}
                onClick={() => {
                  if (!this.props.handleChange) return;
                  this.props.handleChange(key);
                }}
              >
                {item.get("name")}
              </span>
            );
          })}
        {!this.props.list &&
          [
            ...Array(this.props.skeletonCount ? this.props.skeletonCount : 5),
          ].map((item, key) => {
            return (
              <span
                className={`badge badge-secondary disabled`}
                key={key}
                onClick={() => {
                  if (!this.props.handleChange) return;
                  this.props.handleChange(key);
                }}
              >
                <span className="dummy">loading</span>
              </span>
            );
          })}
      </div>
    );
  }
}

export default FitlerList;
